import React from 'react';
import { comparisonData } from '../mockData';
import { X, Check } from 'lucide-react';

const Comparison = () => {
  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-black mb-6">
              Perbedaan Trade Pakai{' '}
              <span className="text-[#ED1C24]">Indikator Biasa vs Indikator SBE</span>
            </h2>
          </div>
          
          <div className="grid md:grid-cols-2 gap-8">
            {/* Indikator Column */}
            <div className="bg-gray-50 rounded-3xl p-8 border-2 border-gray-200">
              <div className="text-center mb-8">
                <div className="w-16 h-16 bg-gray-300 rounded-full flex items-center justify-center mx-auto mb-4">
                  <X className="w-8 h-8 text-gray-600" />
                </div>
                <h3 className="text-2xl font-bold text-gray-800">Indikator Biasa</h3>
              </div>
              
              <ul className="space-y-4">
                {comparisonData.indicator.map((item, index) => (
                  <li key={index} className="flex items-start space-x-3">
                    <div className="w-6 h-6 bg-gray-300 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                      <X className="w-4 h-4 text-gray-600" />
                    </div>
                    <span className="text-gray-700">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
            
            {/* Indikator SBE Column */}
            <div className="bg-gradient-to-br from-[#ED1C24] to-[#c91820] rounded-3xl p-8 border-2 border-[#ED1C24] shadow-2xl relative overflow-hidden">
              <div className="absolute top-0 right-0 w-32 h-32 bg-white/10 rounded-full -mr-16 -mt-16"></div>
              <div className="absolute bottom-0 left-0 w-24 h-24 bg-white/10 rounded-full -ml-12 -mb-12"></div>
              
              <div className="text-center mb-8 relative z-10">
                <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center mx-auto mb-4">
                  <Check className="w-8 h-8 text-[#ED1C24]" />
                </div>
                <h3 className="text-2xl font-bold text-black">Indikator SBE</h3>
              </div>
              
              <ul className="space-y-4 relative z-10">
                {comparisonData.sbe.map((item, index) => (
                  <li key={index} className="flex items-start space-x-3">
                    <div className="w-6 h-6 bg-white rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                      <Check className="w-4 h-4 text-[#ED1C24]" />
                    </div>
                    <span className="text-white font-medium">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Comparison;